const nameData = "ajustes"; // Define la entidad dinámica
const nameDataSingular = "ajuste"; // Para el caso singular

export const fetchEntityData = async (getEntityPanelData,searchIDSel,searchIDDepo,searchID,dateFrom,dateUntil, numPagina, filas) => {
  try {
    const data = await getEntityPanelData(searchIDSel,searchIDDepo,searchID,dateFrom,dateUntil, numPagina, filas);
    if (data) {
      const totalPage = data.pagination.totalPage || 1;
      const totalDataItems = data.pagination.totalItems || 0;
      return {
        dataEntity: data[nameData] || [], // Usa nameData dinámicamente
        totalItems: data.pagination.totalItems || 0,
        totalPage,
        totalDataItems
      };
    }
  } catch (error) {
    console.error(`Error al cargar ${nameData}:`, error);
    throw error;
  }
};
 